import React from 'react'
import PropTypes from 'prop-types'
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts'
import Typography from '../common/Typography/index'

const DonutChartUsers = ({ data }) => {
  const isSimpleDataFormat = Array.isArray(data) && data.every(item =>
    item && typeof item === 'object' && 'name' in item && 'value' in item && 'fill' in item
  )

  const chartData = isSimpleDataFormat ? data : []
  const total = chartData.reduce((sum, item) => sum + item.value, 0)

  if (chartData.length === 0) {
    return (
      <div className="p-4">
        <div className="flex items-center justify-center h-32">
          <Typography className="text-gray-500">No data available</Typography>
        </div>
      </div>
    )
  }

  return (
    <div className="p-4">
      {/* Title */}
       <div className="flex flex-col items-center">
        <ResponsiveContainer width="100%" height={220}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={70}
              outerRadius={90}
              dataKey="value"
              labelLine={false}
              label={({ value, cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
                const radius = innerRadius + (outerRadius - innerRadius) / 2
                const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180))
                const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180))

                return (
                  <g>
                    <foreignObject x={x - 20} y={y - 15} width={40} height={30}>
                      <div
                        xmlns="http://www.w3.org/1999/xhtml"
                        style={{
                          background: '#fff',
                          borderRadius: '9999px',
                          padding: '2px 6px',
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#333',
                          textAlign: 'center',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                      >
                        {(percent * 100).toFixed(0)}%
                      </div>
                    </foreignObject>
                  </g>
                )
              }}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        {/* Inline Legend */}
        <div className="flex justify-center space-x-6 mt-2">
          {chartData.map((item, index) => (
            <div key={index} className="flex items-center text-xs font-medium">
              <span
                className="w-2 h-2 rounded-full mr-2"
                style={{ backgroundColor: item.fill }}
              ></span>
              <span style={{ color: item.fill }}>{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

DonutChartUsers.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  title: PropTypes.string,
}

export default DonutChartUsers
